// extracted by mini-css-extract-plugin
export default {"container":"cVO5hhrNa","currentLanguage":"cmDVz2CBi","regions":"cBwt2yceO","regionsVisible":"ciNdtYCsF"};